import {Injectable} from '@angular/core';
import {PreloadingStrategy, Route} from '@angular/router';
import {Observable, timer} from 'rxjs';
import {shareReplay, switchMap} from 'rxjs/operators';

/** How long after the first navigation the lazy modules start preloading. */
export const PRELOAD_AFTER_STARTUP_MS = 10000;

// ITP-E-322-09. PreloadAllModules started pulling every lazy module (about 18 MB) right at the first navigation, while
// onboarding and the first screen were still loading their own data - on a slow line the two compete for it. This preloads
// the same routes, but only once the start-up has had PRELOAD_AFTER_STARTUP_MS to itself; routes met later preload at once.
@Injectable({providedIn: 'root'})
export class PreloadAfterStartupStrategy implements PreloadingStrategy {
  private startupOver$: Observable<number>;

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    // The router first asks at the first NavigationEnd, so the wait is counted from there.
    this.startupOver$ ??= timer(PRELOAD_AFTER_STARTUP_MS).pipe(shareReplay(1));
    return this.startupOver$.pipe(switchMap(() => load()));
  }
}
